import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const jsonHeaders = () => ({ ...headers(), 'Content-Type': 'application/json' });

async function apiFetch(path: string) {
  const r = await fetch(`${API}${path}`, { headers: headers() });
  return r.ok ? r.json() : [];
}

const RENK = ['#1a5276', '#1f618d', '#2874a6', '#2e86c1'];

interface Tanim {
  id: number;
  kategori: string;
  ust_kategori: string | null;
  ad: string;
  sira: number;
  aktif: number;
}

export default function GenelTanimlar() {
  const _user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = ['super_admin', 'gm_yonetici'].includes(_user?.rol);

  const [liste, setListe] = useState<Tanim[]>([]);
  const [kategoriler, setKategoriler] = useState<string[]>([]);
  const [seciliKategori, setSeciliKategori] = useState<string | null>(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [modalAcik, setModalAcik] = useState(false);
  const [modalMod, setModalMod] = useState<'yeni' | 'duzenle'>('yeni');
  const [form, setForm] = useState<any>({ kategori: '', ad: '', ust_kategori: '', sira: 0 });
  const [duzenlenenId, setDuzenlenenId] = useState<number | null>(null);
  const [hata, setHata] = useState('');
  const [mesaj, setMesaj] = useState('');
  const [pasifGoster, setPasifGoster] = useState(false);
  const [dragId, setDragId] = useState<number | null>(null);
  const [dragHdefId, setDragHdefId] = useState<number | null>(null);
  const [yeniKategori, setYeniKategori] = useState('');
  const [kategoriEkleAcik, setKategoriEkleAcik] = useState(false);

  useEffect(() => { yukle(); }, [pasifGoster]);

  const yukle = async () => {
    setYukleniyor(true);
    const aktifParam = pasifGoster ? 'hepsi' : '1';
    const [data, katData] = await Promise.all([
      apiFetch(`/api/genel-tanimlar/liste?aktif=${aktifParam}`),
      apiFetch('/api/genel-tanimlar/kategoriler')
    ]);
    setListe(data);
    setKategoriler(katData);
    setYukleniyor(false);
  };

  const bildir = (msg: string) => { setMesaj(msg); setTimeout(() => setMesaj(''), 3000); };

  const filtreliListe = seciliKategori
    ? liste.filter(t => t.kategori === seciliKategori)
    : liste;

  const yeniAc = () => {
    setForm({ kategori: seciliKategori || '', ad: '', ust_kategori: '', sira: 0 });
    setDuzenlenenId(null);
    setHata('');
    setModalMod('yeni');
    setModalAcik(true);
  };

  const duzenleAc = (t: Tanim) => {
    setForm({ kategori: t.kategori, ad: t.ad, ust_kategori: t.ust_kategori || '', sira: t.sira });
    setDuzenlenenId(t.id);
    setHata('');
    setModalMod('duzenle');
    setModalAcik(true);
  };

  const kaydet = async () => {
    if (!form.kategori || !form.ad) { setHata('Kategori ve ad zorunlu'); return; }
    try {
      if (modalMod === 'yeni') {
        const r = await fetch(`${API}/api/genel-tanimlar/ekle`, {
          method: 'POST', headers: jsonHeaders(),
          body: JSON.stringify({
            kategori: form.kategori,
            ad: form.ad,
            ust_kategori: form.ust_kategori || null
          })
        });
        if (!r.ok) { const e = await r.json(); setHata(e.detail || 'Hata'); return; }
        bildir('✅ Eklendi');
      } else {
        const r = await fetch(`${API}/api/genel-tanimlar/${duzenlenenId}`, {
          method: 'PUT', headers: jsonHeaders(),
          body: JSON.stringify({
            kategori: form.kategori,
            ad: form.ad,
            ust_kategori: form.ust_kategori || null,
            sira: form.sira
          })
        });
        if (!r.ok) { const e = await r.json(); setHata(e.detail || 'Hata'); return; }
        bildir('✅ Güncellendi');
      }
      setModalAcik(false);
      yukle();
    } catch { setHata('Bağlantı hatası'); }
  };

  const pasifYap = async (id: number) => {
    if (!window.confirm('Bu tanımı pasif yapmak istiyor musunuz?')) return;
    try {
      const r = await fetch(`${API}/api/genel-tanimlar/${id}`, { method: 'DELETE', headers: headers() });
      if (!r.ok) { const e = await r.json(); alert(e.detail || 'Hata'); return; }
      bildir('✅ Pasif yapıldı');
      yukle();
    } catch { alert('Bağlantı hatası'); }
  };

  const aktifEt = async (id: number) => {
    await fetch(`${API}/api/genel-tanimlar/${id}/aktif`, { method: 'PUT', headers: jsonHeaders(), body: '{}' });
    bildir('✅ Aktif edildi');
    yukle();
  };

  // Drag & Drop
  const handleDrop = async (hedefId: number) => {
    if (!dragId || dragId === hedefId) { setDragId(null); setDragHdefId(null); return; }
    const kategoriListe = filtreliListe.filter(t => t.aktif === 1 || pasifGoster);
    const dragIdx = kategoriListe.findIndex(t => t.id === dragId);
    const hedefIdx = kategoriListe.findIndex(t => t.id === hedefId);
    if (dragIdx < 0 || hedefIdx < 0) { setDragId(null); setDragHdefId(null); return; }
    const yeni = [...kategoriListe];
    const [moved] = yeni.splice(dragIdx, 1);
    yeni.splice(hedefIdx, 0, moved);
    const items = yeni.map((t, i) => ({ id: t.id, sira: i }));
    await fetch(`${API}/api/genel-tanimlar/sira/guncelle`, {
      method: 'PUT', headers: jsonHeaders(), body: JSON.stringify({ items })
    });
    setDragId(null); setDragHdefId(null);
    bildir('✅ Sıra güncellendi');
    yukle();
  };

  const kategoriEkle = () => {
    const kat = yeniKategori.trim();
    if (!kat) return;
    if (!kategoriler.includes(kat)) setKategoriler(prev => [...prev, kat]);
    setSeciliKategori(kat);
    setYeniKategori('');
    setKategoriEkleAcik(false);
  };

  const goruntulenenListe = seciliKategori
    ? liste.filter(t => t.kategori === seciliKategori && (pasifGoster || t.aktif === 1))
    : [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 140px)' }}>
      {/* Başlık */}
      <div style={{ paddingBottom: 12, flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h1 style={{ fontSize: 20, color: '#1a5276', margin: 0 }}>🏷️ Genel Tanımlar</h1>
          <p style={{ color: '#666', fontSize: 12, margin: '4px 0 0' }}>
            ⠿ sürükleyerek sıralayın · ✏️ ile düzenleyin · + ile yeni ekleyin
          </p>
          {mesaj && <div style={{ background: '#d5f5e3', color: '#1e8449', padding: '8px 12px', borderRadius: 4, marginTop: 8, fontSize: 13 }}>{mesaj}</div>}
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 12, color: '#888', marginTop: 4, whiteSpace: 'nowrap' }}>
          <input type="checkbox" checked={pasifGoster} onChange={e => setPasifGoster(e.target.checked)} />
          Pasifleri göster
        </label>
      </div>

      {yukleniyor ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, color: '#999' }}>Yükleniyor...</div>
      ) : (
        <div style={{ display: 'flex', gap: 8, flex: 1, overflow: 'hidden' }}>

          {/* SOL: Kategori Listesi */}
          <div style={{ width: 220, display: 'flex', flexDirection: 'column', background: 'white', borderRadius: 6, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden', flexShrink: 0 }}>
            <div style={{ background: RENK[0], color: 'white', padding: '8px 12px', fontSize: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
              <div style={{ fontWeight: 'bold' }}>KATEGORİLER</div>
              {isAdmin && (
                <button onClick={() => setKategoriEkleAcik(!kategoriEkleAcik)}
                  style={{ background: 'rgba(255,255,255,0.25)', border: 'none', color: 'white', borderRadius: 3, padding: '1px 8px', cursor: 'pointer', fontSize: 16 }}>+</button>
              )}
            </div>
            {kategoriEkleAcik && (
              <div style={{ padding: '8px', borderBottom: '1px solid #f0f0f0', background: '#f9f9f9', flexShrink: 0 }}>
                <input value={yeniKategori} onChange={e => setYeniKategori(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && kategoriEkle()}
                  placeholder="yeni_kategori_adi" autoFocus
                  style={{ width: '100%', padding: '4px 6px', border: '1px solid #ddd', borderRadius: 3, fontSize: 11, boxSizing: 'border-box' }} />
                <div style={{ display: 'flex', gap: 4, marginTop: 4 }}>
                  <button onClick={kategoriEkle} style={{ flex: 1, background: RENK[0], color: 'white', border: 'none', borderRadius: 3, padding: '3px', cursor: 'pointer', fontSize: 11 }}>Ekle</button>
                  <button onClick={() => setKategoriEkleAcik(false)} style={{ flex: 1, background: '#eee', border: 'none', borderRadius: 3, padding: '3px', cursor: 'pointer', fontSize: 11 }}>İptal</button>
                </div>
              </div>
            )}
            <div style={{ overflow: 'auto', flex: 1 }}>
              <div
                onClick={() => setSeciliKategori(null)}
                style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', background: !seciliKategori ? '#eaf4fb' : 'white', borderLeft: `3px solid ${!seciliKategori ? RENK[0] : 'transparent'}`, fontSize: 12, color: !seciliKategori ? RENK[0] : '#555', fontWeight: !seciliKategori ? 'bold' : 'normal' }}>
                Tümü ({liste.filter(t => pasifGoster || t.aktif === 1).length})
              </div>
              {kategoriler.map(kat => {
                const sayisi = liste.filter(t => t.kategori === kat && (pasifGoster || t.aktif === 1)).length;
                const secili = seciliKategori === kat;
                return (
                  <div key={kat} onClick={() => setSeciliKategori(kat)}
                    style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', background: secili ? '#eaf4fb' : 'white', borderLeft: `3px solid ${secili ? RENK[0] : 'transparent'}`, fontSize: 12 }}>
                    <div style={{ color: secili ? RENK[0] : '#333', fontWeight: secili ? 'bold' : 'normal', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{kat}</div>
                    <div style={{ fontSize: 10, color: '#aaa' }}>{sayisi} kayıt</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* SAĞ: Tanım Listesi */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: 'white', borderRadius: 6, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
            <div style={{ background: seciliKategori ? RENK[1] : '#999', color: 'white', padding: '8px 12px', fontSize: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
              <div>
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.65)', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                  {seciliKategori ? 'KATEGORİ' : ''}
                </div>
                <div style={{ fontWeight: 'bold' }}>{seciliKategori || 'Bir kategori seçin'}</div>
              </div>
              {seciliKategori && isAdmin && (
                <button onClick={yeniAc}
                  style={{ background: 'rgba(255,255,255,0.25)', border: 'none', color: 'white', borderRadius: 3, padding: '1px 8px', cursor: 'pointer', fontSize: 16 }}>+</button>
              )}
            </div>

            <div style={{ overflow: 'auto', flex: 1 }}>
              {!seciliKategori ? (
                <div style={{ padding: 24, color: '#999', textAlign: 'center' }}>
                  <div style={{ fontSize: 36, marginBottom: 8 }}>🏷️</div>
                  <div>Sol taraftan bir kategori seçin</div>
                  <div style={{ fontSize: 11, color: '#bbb', marginTop: 4 }}>veya + ile yeni kategori ekleyin</div>
                </div>
              ) : goruntulenenListe.length === 0 ? (
                <div style={{ padding: 24, color: '#999', textAlign: 'center' }}>
                  <div style={{ fontSize: 24 }}>📋</div>Kayıt yok<br />
                  <span style={{ fontSize: 11 }}>+ ile ekleyin</span>
                </div>
              ) : goruntulenenListe.map(t => {
                const isDragging = dragId === t.id;
                const isDragOver = dragHdefId === t.id && dragId !== t.id;
                const isPasif = t.aktif === 0 || (t.aktif as any) === false;
                return (
                  <div key={t.id} draggable
                    onDragStart={() => setDragId(t.id)}
                    onDragOver={e => { e.preventDefault(); setDragHdefId(t.id); }}
                    onDrop={() => handleDrop(t.id)}
                    onDragEnd={() => { setDragId(null); setDragHdefId(null); }}
                    style={{
                      padding: '8px 12px', borderBottom: '1px solid #f0f0f0', display: 'flex',
                      alignItems: 'center', justifyContent: 'space-between',
                      background: isPasif ? '#fff8f0' : isDragOver ? '#d4e6f1' : isDragging ? '#f0f0f0' : 'white',
                      borderLeft: `3px solid ${isDragOver ? '#2471a3' : isPasif ? '#e67e22' : 'transparent'}`,
                      opacity: isDragging ? 0.5 : isPasif ? 0.7 : 1, cursor: 'pointer'
                    }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1, minWidth: 0 }}>
                      <span style={{ color: '#ccc', fontSize: 12, cursor: 'grab', flexShrink: 0 }}>⠿</span>
                      <div style={{ minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 'normal', color: isPasif ? '#e67e22' : '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {isPasif && '⚠ '}{t.ad}
                        </div>
                        <div style={{ fontSize: 10, color: '#aaa', display: 'flex', gap: 6 }}>
                          <span>#{t.id}</span>
                          {t.ust_kategori && <span style={{ background: '#eaf0fb', color: '#2471a3', padding: '0 4px', borderRadius: 3 }}>{t.ust_kategori}</span>}
                          {isPasif && <span style={{ background: '#fdead0', color: '#e67e22', padding: '0 4px', borderRadius: 3 }}>pasif</span>}
                        </div>
                      </div>
                    </div>
                    {isAdmin && (
                      <div style={{ display: 'flex', gap: 2, flexShrink: 0, marginLeft: 4 }} onClick={e => e.stopPropagation()}>
                        {isPasif ? (
                          <button onClick={() => aktifEt(t.id)} title="Aktif Et"
                            style={{ background: '#27ae60', border: 'none', color: 'white', borderRadius: 3, padding: '2px 5px', cursor: 'pointer', fontSize: 10 }}>✔</button>
                        ) : (
                          <>
                            <button onClick={() => duzenleAc(t)} title="Düzenle"
                              style={{ background: '#e67e22', border: 'none', color: 'white', borderRadius: 3, padding: '2px 5px', cursor: 'pointer', fontSize: 10 }}>✏</button>
                            <button onClick={() => pasifYap(t.id)} title="Pasif Yap"
                              style={{ background: 'none', border: 'none', color: '#ccc', cursor: 'pointer', fontSize: 14 }}>×</button>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 400 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{modalMod === 'yeni' ? '+ Yeni Tanım' : '✏️ Düzenle'}</h3>
              <button className="modal-close" onClick={() => setModalAcik(false)}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}
              <div className="form-group">
                <label>Kategori *</label>
                <input className="form-control" value={form.kategori}
                  onChange={e => setForm({ ...form, kategori: e.target.value })}
                  placeholder="buyukbas_irk" list="kategori-list" />
                <datalist id="kategori-list">
                  {kategoriler.map(k => <option key={k} value={k} />)}
                </datalist>
              </div>
              <div className="form-group">
                <label>Ad *</label>
                <input className="form-control" value={form.ad} autoFocus
                  onChange={e => setForm({ ...form, ad: e.target.value })}
                  placeholder="Holstein (Siyah Alaca)" />
              </div>
              <div className="form-group">
                <label>Üst Kategori <small style={{ color: '#999' }}>(opsiyonel)</small></label>
                <input className="form-control" value={form.ust_kategori}
                  onChange={e => setForm({ ...form, ust_kategori: e.target.value })}
                  placeholder="örn: sut_irki" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
